<template>
  <div class="page-users">
    <div class="columns">
      <div class="column content">
        <p class="title">
          Users.
        </p>
        <div class="control notification is-danger" v-if="error">
          <button class="delete" @click="error = undefined"></button>
          {{ error }}
        </div>
        <b-table
          :data="tableData"
          :bordered="isBordered"
          :striped="isStriped"
          :narrowed="isNarrowed"
          :checkable="isCheckable"
          :loading="isLoading"
          :mobile-cards="hasMobileCards"
          :paginated="isPaginated"
          :per-page="50"
          :pagination-simple="true"
          default-sort="user.first_name"
          :selected.sync="selected"
          :checked-rows.sync="checkedRows">

          <template slot-scope="props">
            <b-table-column field="identifier" label="ID" width="40" sortable numeric>
              {{ props.row.identifier }}
            </b-table-column>

            <b-table-column field="username" label="User Name" sortable>
              {{ props.row.username }}
            </b-table-column>

            <b-table-column field="email" label="Email" sortable>
              {{ props.row.email }}
            </b-table-column>

            <b-table-column field="role" label="Role" sortable>
              <span class="tag"
                :class="{
                  'is-warning': (props.row.role === 'root'),
                  'is-danger': (props.row.role === 'admin'),
                  'is-success': (props.row.role === 'user') }">
                {{ props.row.role }}
              </span>
            </b-table-column>

            <b-table-column field="isVerified" label="Verified" sortable>
              <b-icon
                pack="mdi"
                :icon="props.row.isVerified  ? 'done' : 'close'">
              </b-icon>
            </b-table-column>

            <!-- date: {{ new Date(props.row.date).toLocaleDateString() }} -->
          </template>

          <div slot="empty" class="has-text-centered">
            <span style="color:#ccc;">Table contains nothing.</span>
          </div>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import auth from '@/apis/Auth'
export default {
  data () {
    return {
      tableData: [],
      checkedRows: [],
      selected: {},
      isBordered: false,
      isStriped: false,
      isNarrowed: false,
      isCheckable: false,
      isLoading: false,
      hasMobileCards: true,
      isPaginated: true,
      error: undefined
    }
  },
  computed: mapGetters([
    'evenOrOdd',
    'isAuthenticated'
  ]),
  methods: {
    test () {
    },
    ...mapActions([
      'authenticated',
      'unauthenticated'
    ])
  },
  beforeCreate () {
  },
  created () {
    console.log('created Users.vue')

    this.isLoading = true
    auth.users(this.credentials)
    .then(data => {
      console.log('get users')
      console.log(data)
      this.tableData = data.data
      this.isLoading = false
    })
    .catch(error => {
      console.log('invalid get users', error)
      this.error = error.error
      this.isLoading = false
    })
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.page-users {
}
</style>



// WEBPACK FOOTER //
// Users.vue?bbfa5d26